module.exports = __webpack_public_path__ + "static/media/littleBigWave.3ab2c274.jpg";